// ** Icons Import
import { Circle } from 'react-feather'

export default [
    {
        id: 'Definition',
        title: 'Тодорхойлолт',
        icon: <i className="far fa-file-chart-line"></i>,
        navLink: "/Definition",
        children: [
            {
                id: 'learning-true',
                title: 'Тодорхойлолт',
                icon: <Circle size={8} />,
                navLink: "definition/learning-true"
            },
            {
                id: 'amount-details',
                title: 'Дүнгийн дэлгэрэнгүй',
                icon: <Circle size={8} />,
                navLink: "definition/amount-details/"
            },
            {
                id: 'sum',
                title: 'Голч дүн',
                icon: <Circle size={8} />,
                navLink: "definition/sum/"
            },
            // NOTE: KHERLEN -> Dynamic-аар утга өгцөн болохоор түр хаав
            // {
            //     id: 'credit-calculation',
            //     title: 'Судлах кредитийн тооцоо дэд цэс үүсгэх',
            //     icon: <Circle size={8} />,
            //     navLink: "definition/credit-calculation/"
            // },
        ]
    }
]